<template>
  <div class="roles-list">
    <div class="app-list">
      <template v-if="isLoaded && roles.length && !isFailed">
        <div class="roles-list__list-wrp">
          <role-card
            v-for="item in roles"
            :key="`roles-${item.id}`"
            :role="item"
          />
          <permission-wrapper
            skip-alert
            page-name="roles"
            resource-name="role"
            action-name="create">
            <role-card-create />
          </permission-wrapper>
        </div>
      </template>

      <template v-else>
        <div class="app-list__li-like">
          <template v-if="isLoaded && !roles.length">
            <p>
              {{ "roles-list.nothing-here-yet" | globalize }}
            </p>
          </template>

          <template v-else-if="isFailed">
            <p>
              {{ "roles-list.default-error-message" | globalize }}
            </p>
          </template>

          <template v-else>
            <p>
              {{ "roles-list.loading-message" | globalize }}
            </p>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import RolesMixin from '@/vue/mixins/roles.mixin'
import RoleCard from './components/RoleCard'
import RoleCardCreate from './components/RoleCard.Create'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'roles-list',
  components: {
    RoleCard,
    RoleCardCreate,
    PermissionWrapper,
  },
  mixins: [ RolesMixin ],

  async created () {
    await this.loadRoles()
  },
}
</script>

<style lang="scss" scoped>
.roles-list__list-wrp {
  display: grid;
  grid-template-columns: repeat(auto-fill, 35rem);
  grid-auto-rows: 1fr;
  gap: 4rem;
}
</style>
